import React, { useState, useEffect } from 'react'
import clsx from 'clsx'

import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Image } from '@/components/atoms/Image/Image'
import { MegaMenu } from '@/components/organisms/MegaMenu/MegaMenu'
import { setViewHeight } from '@/helpers/setViewHeight'
import { ReactComponent as CloseIcon } from '@/assets/icons/X.svg'
import { ReactComponent as Arrow } from '@/assets/icons/thin-arrow-purple.svg'
import LogIn from '../LogIn'
import { NavigationProps } from './types'

export function MobileNavigation({ links, logo, handleOpen, isOpen, simple, buttons }: NavigationProps) {
  const [isDropdownOpen, setDropdownOpen] = useState(false)
  const [dropdownIndex, setIndex] = useState(null)

  const handleDropdownOpen = (index: any) => {
    setIndex(index)
    if (isDropdownOpen && index !== dropdownIndex) {
      setDropdownOpen(false)
    }
    setDropdownOpen((val) => !val)
  }

  useEffect(() => {
    window.addEventListener('resize', setViewHeight)
    return () => {
      window.removeEventListener('resize', setViewHeight)
    }
  }, [])

  return (
    <div>
      {isOpen && (
        <div className="flex flex-col w-full fixed top-0 left-0 z-10 bg-white overflow-hidden h-full">
          <div className="flex justify-between items-center p-24 flex-shrink-0">
            <CustomLink
              is_external={false}
              link_url={{ cached_url: '', id: 'logo-link', url: '', fieldtype: 'multilink', linktype: '' }}
              new_tab={false}
            >
              <Image fixed data={logo} options={{ width: 103 }} className="w-131" />
            </CustomLink>
            <button onClick={handleOpen} type="button" aria-label="Close menu">
              <CloseIcon />
            </button>
          </div>
          <div className="border-t-2 border-grey-100 mx-24" />
          <nav className={clsx('flex flex-col  pt-32 overflow-y-auto h-full')}>
            {!simple && (
              <ul className="flex flex-col gap-32">
                {links &&
                  links.map((link, index) => (
                    <li className="font-bold text-text-dark-900 text-bodyL last:mb-32" key={link._uid}>
                      {link.dropdown_menu ? (
                        <div>
                          <span
                            onClick={() => handleDropdownOpen(index)}
                            className="flex items-center justify-between cursor-pointer px-24"
                            aria-hidden="true"
                          >
                            {link.text}
                            {isDropdownOpen && index === dropdownIndex ? (
                              <span className="[&>svg]:size-16 -rotate-90 transition">
                                <Arrow />
                              </span>
                            ) : (
                              <span className="[&>svg]:size-16 rotate-90 transition">
                                <Arrow />
                              </span>
                            )}
                          </span>
                          {isDropdownOpen && index === dropdownIndex && (
                            <MegaMenu menus={link.dropdown_menu} variant={link.variant} />
                          )}
                        </div>
                      ) : (
                        <CustomLink {...link} className="px-24">
                          {link.text}
                        </CustomLink>
                      )}
                    </li>
                  ))}
              </ul>
            )}
          </nav>
          <div className="flex w-full py-16 px-24 shadow-megamenu">
            <LogIn buttons={buttons} />
          </div>
        </div>
      )}
    </div>
  )
}
